<mat-form-field color="primary" appearance="outline">
  <mat-label class="text-sm md:text-base">{{ label }}</mat-label>

  <mat-select [formControl]="control">
    @for (option of options; track trackByOptions($index, option)) {
      <mat-option [value]="option.value" [ngClass]="option.styleOption">
        {{ option.displayName }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
